import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import SkipNextIcon from '@mui/icons-material/SkipNext'
import { Button, Grid, useMediaQuery, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'

import SubmitButton from './forms/SubmitButtonWrapper'

interface OnboardStepperProps {
  activeStep: number
  handleBack: () => void
  isNextButtonDisabled: boolean
  maxSteps: number
  required: boolean
  skipStep: () => void
  submitting: boolean
}

const OnboardStepper = (props: OnboardStepperProps) => {
  const { t } = useTranslation()

  const theme = useTheme()
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('md'))
  const {
    activeStep,
    handleBack,
    isNextButtonDisabled,
    maxSteps,
    required,
    skipStep,
    submitting,
  } = props

  return (
    <Grid
      container
      sx={{
        backgroundColor: '#FFF',
        bottom: 0,
        left: 0,
        p: 1,
        position: 'fixed',
        right: 0,
        zIndex: 1000,
        ...(isLargeScreen ? { justifyContent: 'center' } : null),
      }}
    >
      <Grid item xs={isLargeScreen ? 4 : 12}>
        <Grid container>
          <Grid item xs={6}>
            <Button
              disabled={activeStep === 0}
              onClick={handleBack}
              size={isLargeScreen ? 'large' : 'small'}
              startIcon={<KeyboardArrowLeftIcon />}
            >
              {t('general.back')}
            </Button>
          </Grid>
          <Grid
            item
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
            }}
            xs={6}
          >
            {!required && (
              <Button
                disabled={submitting}
                onClick={skipStep}
                size={isLargeScreen ? 'large' : 'small'}
                sx={{
                  mx: 2,
                }}
                variant="text"
              >
                {t('general.skip')}
                <SkipNextIcon />
              </Button>
            )}
            <SubmitButton
              disabled={submitting || isNextButtonDisabled}
              endIcon={<KeyboardArrowRightIcon />}
            >
              {activeStep === maxSteps - 1
                ? t('general.finish')
                : t('general.next')}
            </SubmitButton>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default OnboardStepper
